<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-arrows-down`]" width="1em" height="1em" v-bind="$attrs"><path d="M7.99956 2.92969C8.36683 2.92969 8.6646 3.22746 8.6646 3.59473V10.7969L11.0289 8.43262C11.2886 8.17293 11.7106 8.17294 11.9703 8.43262C12.23 8.69232 12.23 9.11432 11.9703 9.37402L8.47027 12.874C8.21055 13.1335 7.78847 13.1336 7.52886 12.874L4.02886 9.37402C3.76927 9.11441 3.76943 8.69233 4.02886 8.43262C4.28855 8.17293 4.71057 8.17294 4.97027 8.43262L7.33452 10.7969V3.59473C7.33452 3.22755 7.63242 2.92984 7.99956 2.92969Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineArrowsDown',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
